import { createAction } from 'redux-actions';

import { RefundPassengersState } from '../types';

export const SET_PASSENGERS = 'REFUND/SET_PASSENGERS';
export const SET_PASSENGER_SELECT = 'REFUND/SET_PASSENGER_SELECT';
export const SET_ALL_PASSENGER_SELECT = 'REFUND/SET_ALL_PASSENGER_SELECT';

export interface SetPassengerSelectPayload {
	id: string | string[];
	selected: boolean;
}

export interface SetAllPassengerSelectPayload {
	selected: boolean;
}

export const setPassengers = createAction<RefundPassengersState>(SET_PASSENGERS);

export const setPassengerSelect = createAction<SetPassengerSelectPayload>(SET_PASSENGER_SELECT);

export const setAllPassengerSelect = createAction<SetAllPassengerSelectPayload>(SET_ALL_PASSENGER_SELECT);

export type SetPassengersAction = ReturnType<typeof setPassengers>;
export type SetPassengerSelectAction = ReturnType<typeof setPassengerSelect>;
export type SetAllPassengerSelectAction = ReturnType<typeof setAllPassengerSelect>;

export type ActionPassengerTypes = SetPassengersAction | SetPassengerSelectAction | SetAllPassengerSelectAction;
